<span class="caption-cell__text">{{ text }}</span>
<span class="caption-cell__caption" *ngIf="caption">{{ caption }}</span>
